import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Logout: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.708 24.95c.147 0 .267-.12.267-.267v-4.666h1.733v4.666c0 1.107-.906 2-2 2H4.375c-1.107 0-2-.893-2-2V7.35c0-1.107.893-2 2-2h13.333c1.094 0 2 .893 2 2v4.667h-1.733V7.35a.267.267 0 0 0-.267-.266H4.375a.267.267 0 0 0-.267.266v17.333c0 .147.12.267.267.267h13.333Zm4.72-14.88a.877.877 0 0 1 1.227 0l5.947 5.947-5.947 5.946a.847.847 0 0 1-.613.254.846.846 0 0 1-.614-.254.877.877 0 0 1 0-1.226l3.854-3.854H13.415V15.15h12.867l-3.854-3.853a.877.877 0 0 1 0-1.227Z"
      clipRule="evenodd"
    />
  </Icon>
);
